var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"base-primary-button",class:{ light: _vm.light },attrs:{"disabled":_vm.disabled,"color":"primary","text":_vm.text,"loading":_vm.loading,"dense":_vm.dense,"fullWidth":_vm.fullWidth,"shrink":_vm.shrink},on:{"click":_vm.handleClick}},[_vm._t("prepend:icon"),_vm._t("default"),_vm._t("append:icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }